import styled from "styled-components";

export const ProductsListHead = styled.div`
	min-width: 1100px;
	width: 100%;
	display: flex;
	align-items: center;
	font-weight: 700;
	&& > div {
		min-height: unset;
		position: relative;
	}
	&& > div:not(:last-child)::after {
		content: "";
		position: absolute;
		right: 0;
		top: 10%;
		height: 80%;
		width: 1px;
		background-color: #ebebeb;
	}
`;

export const CollapseWrapper = styled.div`
	&&& .MuiCollapse-root {
		min-width: 1100px;
	}
`;

export const RowWrapper = styled.div`
	min-width: 1100px;
	width: 100%;
	.box-layout-card-collumn {
		display: flex;

		width: 100%;
		align-items: stretch;
		border-radius: 0px;
		box-shadow: none;
		padding: 0.8rem 0rem;
		border: 1px solid ${({ theme }) => theme.pantone642C};

		&.supplier-recommended {
			border: 1px solid ${({ theme }) => theme.pantone2726C};
		}
	}
`;
